import React, { useEffect, useState } from "react";
import {
    useTheme,
    TextField,
    IconButton,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Grid,
    Paper,
    Box,
    FormControl,
    NativeSelect,
    InputLabel,
    Card,
    CardContent,
    Typography,
    Select,
    MenuItem,
    Tooltip,
    Tab,
    Tabs,
    InputAdornment,
    Skeleton
  } from "@mui/material";
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FaEdit, FaTrash, FaInfoCircle } from "react-icons/fa";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import SearchIcon from '@mui/icons-material/Search';
import { ToastContainer, toast } from "react-toastify";
import baseURL from "../config";
import CryptoJS from "crypto-js";
import RecordsTable from "../Components/RecordsTable";

const Pos = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filteredposData, setFilteredposData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedPos, setSelectedPos] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [brandName, setBrandName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [posData, setPosData] = useState({
    posid: 0,
    address: "",
    name: "",
    latitude: 0.0,
    longitude: 0.0,
    workingHours: "",
    brandId: 1,
    location: "",
    website: "",
    phone: "",
    brand: {
      brandId: 0,
      name: "",
      companyId: 0,
      image: "",
    description: "",
      company: null,
      offers: [],
      pointOfSales: [
        {
        }
      ]
    },
    bonusPoints: [],
    failedTransactions: [],
    scannedClients: [],
    terminals: [],
    transactions: []
});

const getDecryptedToken = () => {
  const encryptedToken = Cookies.get("token");
  if (!encryptedToken) return null;

  const secretKey = '19092002'; 
  const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
  const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

  return decryptedToken || null;
};


const token = getDecryptedToken();

//api calls
const fetchPos = async () => {
  try {
    const response = await axios.get(
        baseURL+ "/api/PointOfSale/GetPOS",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

        if(response.status == 200){
            const pos = response.data;
            setFilteredposData(pos);
            console.log(response.data)
          }
        } catch (error) {
          toast.error("Error fetching client data:", error);
        }
      };
      
      useEffect(() => {
        const fetchPos = async () => {
          try {
            const response = await axios.get(
              baseURL+ "/api/PointOfSale/GetPOS",
              {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.status == 200){
        setIsLoading(false);
        setFilteredposData(response.data)
      }
    
    } catch (error) {
      toast.error("Error fetching client data:", error);
    }
  };

  fetchPos();
}, []);
//this method fetches a pos based on id
const fetchPosbyId = async (posId) => {
    try {
      const response = await axios.get(
        baseURL+"/api/PointOfSale/GetPOSById", 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: posId, 
          },
        }
      );
  
      if (response.status == 200) {
        const pos = response.data;
        setPosData(pos);
      } else {
        toast.error("Failed to fetch pos: Success flag is false");
      }
    } catch (err) {
      toast.error("Error fetching pos:", err);
    }
  };

  const fetchBrandName = async (brandId) => {
    try{
      const response = await axios.get(
        baseURL+"/api/Brands/GetBrandById", 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: brandId
          },
        }
      );
      if(response.status == 200)
        {
          const brand = response.data.brand;

          setBrandName(brand.name);
          

      }else {

      }
    }   catch (err){
      
    } 
  }

  const handleSave = async () => {
    try {
      const response = await axios.post(
        baseURL+"/api/PointOfSale/EditPos", 
        posData, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.status == 200) {
      await fetchPos();
        setDialogOpen(false);
  
       
        toast.success("Pos u perditesua me sukses!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Failed to update pos: Success flag is false");
      }
    } catch (error) {
      console.error("Error updating pos:", error);
      alert("Failed to update user.");
    }
  };  

  const handleEdit = (event) => {
    setPosData({
      ...posData,
      [event.target.name]: event.target.value,
    });
  
  };

  const handleInfo = (id, brandId) => {
    fetchPosbyId(id);
    setSelectedPos(id);
    fetchBrandName(brandId)
    setDialogOpen(true);
    
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onDeleteClick = (id) => {

  }

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };
  
  const filteredData = filteredposData.filter((pos) => {
    const name = pos.name?.toLowerCase() || ""; 
    const location = pos.location?.toLowerCase() || ""; 
    const longitude = pos.longitude?.toLowerCase() || ""; 
    const latitude = pos.latitude?.toLowerCase() || "";
  
    return (
      name.includes(searchQuery) ||
      location.includes(searchQuery) ||
      longitude.includes(searchQuery) ||
      latitude.includes(searchQuery)
    );
  });
  

  const desktopColumns = [
    {
      field: "posid",
      headerName: "ID",
      headerClassName: 'super-app-theme--header',
      flex: 0.35,
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: 'super-app-theme--header',
      flex: 1.2,
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "brandId",
      headerName: "Brand",
      headerClassName: 'super-app-theme--header',
      flex: 0.7,
      renderCell: (params) => <span className="table-pill">#{params.value}</span>,
    },
    {
      field: "longitude",
      headerName: "Longitude",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-muted">{Number(params.value || 0).toFixed(5)}</span>,
    },
    {
      field: "latitude",
      headerName: "Latitude",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-muted">{Number(params.value || 0).toFixed(5)}</span>,
    },
    { field: "location", headerName: "Location", headerClassName: 'super-app-theme--header', flex: 1.2 },
  
        {
            field: "Actions",
            headerName: "",
            flex: 0.35,
            sortable: false,
            filterable: false,
            headerClassName: 'super-app-theme--header',
      
            renderCell: (params) => {
              return (
                <>
                  <IconButton
                    onClick={() => handleInfo(params.row.posid, params.row.brandId)}
                    className="table-action-button"
                    aria-label="Edit POS"
                  >
                    <DriveFileRenameOutlineIcon />
                  </IconButton>    
                </>
              );
            },
          },
        ];

  const mobileColumns = [
    {
      field: "posid",
      headerName: "ID",
      headerClassName: 'super-app-theme--header',
      flex: 0.4,
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "name",
      headerName: "Name",
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "Actions",
      headerName: "",
      flex: 0.5,
      sortable: false,
      filterable: false,
      headerClassName: 'super-app-theme--header',

      renderCell: (params) => {
        return (
          <>
            <IconButton
              onClick={() => handleInfo(params.row.posid, params.row.brandId)}
              className="table-action-button"
              aria-label="Edit POS"
            >
              <DriveFileRenameOutlineIcon />
            </IconButton>    
          </>
        );
      },
    },
  ]

  const columns = isNonMobile ? desktopColumns : mobileColumns

  return (
    <Box m="10px">
      <Header title="Pikat e shitjes" subtitle="Edito pikat e shitjes" />
      <ToastContainer />
      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      <Link to="/posForm" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.primary[700] ,  marginLeft: "20px", marginTop: "8px"}}
        >
          Shto Pika te shitjes
        </Button>
      </Link>
      </Box>

      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"},
          "& .MuiButtonBase-root": {color: colors.redAccent[500]}

        }}
      >
        <div style={{ width: '100%' }}>
        {isLoading ? (
         
         <Skeleton
           variant="rectangular"
           width="100%"
           height={500}
           animation="wave"
         />
       ) : (
        <RecordsTable
          columns={columns}
          rows={filteredData}
          getRowId={(row) => row.posid}
          onRowDoubleClick={(params) => handleInfo(params.row.posid, params.row.brandId)}
          emptyMessage="No POS locations match your search."
        />
       )}
        </div>
        {/* This dialog opens the info about a selected client */}
              <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
          <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500] }}
          >
            
              <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {tabValue}  
                >
                  <Tab
                    label="Info per POS"
                    sx={{
                      color: "white",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  
                  </Tabs>
                  
              </div>

              <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >
                    <TextField
                      label="Name"
                      name="name"
                      value={posData.name ? posData.name : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Brand ID"
                      name="brandId"
                      value={posData.brandId ? posData.brandId : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                      <TextField
                      label="Brand Name"
                      name="brandName"
                      value={brandName ? brandName : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Longitude"
                      name="longitude"
                      value={posData.longitude ? posData.longitude : ""}
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                    <TextField
                      label="Latitude"
                      name="latitude"
                      value={
                        posData.latitude ? posData.latitude : ""
                      }
                      onChange={handleEdit}
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      variant="filled"
                      margin="dense"
                    />
                 
                    <TextField
                      label="Location"
                      name="location"
                      value={posData.location ? posData.location : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "30px",
                      }}
                       
                    />
                    <TextField
                      label="Website"
                      name="website"
                      value={posData.website ? posData.website : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                    <TextField
                      label="Address"
                      name="address"
                      value={posData.address ? posData.address : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                    <TextField
                      label="Phone"
                      name="phone"
                      value={posData.phone ? posData.phone : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                      
                    />
                    <TextField
                      label="Working Hours"
                      name="workingHours"
                      value={posData.workingHours ? posData.workingHours : ""}
                      onChange={handleEdit}
                      variant="filled"
                      margin="dense"
                      
                      style={{
                        marginRight: isNonMobile ? "30px" : "0px",
                        marginTop: isNonMobile ? "20px" : "10px",
                      }}
                    />
                  </div>
          <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{ backgroundColor: "white" }}
                >
                  Save
                </Button>
              </DialogActions>
              </DialogContent>
              </Dialog>
      </Box>
    </Box>
  );
};

export default Pos;
